// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28gaM","question":"styles_question__30mVw","inputVisibleButton":"styles_inputVisibleButton__3gDmV","note":"styles_note__2-Bxf"};